const Footer = () => {
  return (
    <footer className="bg-gray-200 dark:bg-gray-900 dark:text-gray-200 text-center italic font-medium p-4 mt-auto">
      by <a
          className="text-orange-500"
           href="https://github.com/vlrnsnk"
           target="_blank"
           rel="noopener noreferrer"
          >
            vlrnsnk
          </a>
    </footer>
  );
};

export { Footer };
